import { render, staticRenderFns } from "./editing_card.vue?vue&type=template&id=3edf3bc1&scoped=true&"
import script from "./editing_card.vue?vue&type=script&lang=js&"
export * from "./editing_card.vue?vue&type=script&lang=js&"
import style0 from "./editing_card.vue?vue&type=style&index=0&id=3edf3bc1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3edf3bc1",
  null
  
)

export default component.exports